export default __webpack_public_path__ + "static/media/Enara_Logo_Teal_RGB.37c9dd56.png";